/*
 Displays a user's average rating and currently reading book in newsfeed item
 bodies. Currently used in Friend and UserFollowing updates.
 */
import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";

export default GrComponentFactory.createClass({
  displayName: "UserRatingAndCurrentlyReading",

  propTypes: {
    ratingDetailsText: React.PropTypes.string,
    currentlyReadingBook: GrPropTypes.book(),
  },

  renderRatingDetailsText() {
    if (this.props.ratingDetailsText) {
      return <div className="gr-newsfeedItem__ratingDetailsText u-defaultType">
               {this.props.ratingDetailsText}
             </div>;
    } else {
      return null;
    }
  },

  renderCurrentlyReadingBook() {
    if (this.props.currentlyReadingBook) {
      return <div className="gr-metaText u-marginTopXSmall">
               Currently Reading:
               <a href={this.props.currentlyReadingBook.bookUrl}
                  className="gr-hyperlink gr-hyperlink--bold gr-newsfeedItem__currentlyReadingBookTitleLink">
                 {this.props.currentlyReadingBook.title}
               </a>
             </div>;
    } else {
      return null;
    }
  },

  render() {
    if (this.props.ratingDetailsText || this.props.currentlyReadingBook) {
      return <div>
               {this.renderRatingDetailsText()}
               {this.renderCurrentlyReadingBook()}
             </div>;
    } else {
      return null;
    }
  },
});
